import { ReactElement } from "react";
import { useAppSelector } from "../app/hooks";
import { CommonState } from "../app/interfaces/common";
import { getPromoCode } from "../app/utils/promocode";
import { copyCode } from "../app/utils/elements";
import { marketUrl } from "../app/config";

export const PromoCode = (): ReactElement => {
  const { code, codeText } = useAppSelector((state: CommonState) => state.app)
  const promoCode = getPromoCode(code);



  return (
    <div className={'promo-code'}>
      <div className={'pb_promo-code bubble bubble_purple bubble_bottom'}>
        <h1 className={'headline font_beige'}>Твоя выгода<br/> на {promoCode.value} при
          покупке<br/> от {promoCode.purchase} рублей!</h1>
        <p className={'font_white font_bigger'}>
          Нажми, чтобы скопировать
        </p>
        <p className={'font_white '}>
          Промокод отправлен тебе на почту
        </p>
        <div className={'code__wrap'} onClick={() => copyCode(promoCode.code, '.code__text')}>
          <span className={'code__text'}>{promoCode.code}</span>
        </div>
        <div className={'rules__gears rules__gears_10'}/>
      </div>
      <div className="rules__machine-wrap">
        <div className="rules__machine"/>
      </div>
      <a rel="noreferrer" className={'button button_green button_long-text button_megamarket-link'} href={marketUrl} target={'_blank'}>За
        покупками в Мегамаркет</a>
    </div>
  )
}